import React, { useEffect, useState } from "react";

import { Button, Card, Container, Form, Input, Label } from "reactstrap";
import { Autocomplete, TextField } from "@mui/material";
import { fetchSchoolStates } from "store/actions/athleteActions";
import { newSchoolsData } from "store/actions/newSchoolsAction";
import { useDispatch, useSelector } from "react-redux";
import { getSchoolCounty } from "store/actions/athleteActions";
import { findContract } from "store/actions/requestSchoolContractsAction";
import { toast } from "react-toastify";
import { useHistory, Link } from "react-router-dom/cjs/react-router-dom.min";
import { IoMdArrowBack } from "react-icons/io";
import { newCollegeUniversities } from "store/actions/newCollegeUniversities";
import { fetchStates } from "store/actions/athleteActions";
import { getCollegeCity } from "store/actions/athleteActions";

const SearchSchoolContract = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showInstruction, setShowInstruction] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [state, setState] = useState("");
  const [college, setCollege] = useState("");
  const [newSchool, setNewSchool] = useState("");
  const [contractLevel, setContractLevel] = useState("College contract");
  const { states, schoolStates, counties, cities } = useSelector(
    (state) => state.athlete
  );
  const { newSchoolsAllData } = useSelector((state) => state.schools);
  const { getContract } = useSelector((state) => state.contract);
  const { newCollegeUniversitiesData } = useSelector(
    (state) => state.collegeAndUniversities
  );
  const showInstructionToggle = () => {
    setShowInstruction(!showInstruction);
  };
  const showSearchToggle = () => {
    setShowSearch(!showSearch);
    setShowInstruction(false);
  };
  useEffect(() => {
    showInstructionToggle();
  }, []);
  useEffect(() => {
    if (state != "" && college != "") {
      if (contractLevel == "College contract") {
        dispatch(newCollegeUniversities(state, college));
      } else {
        dispatch(newSchoolsData(state, college));
      }
    }
  }, [state, college]);

  useEffect(() => {
    dispatch(fetchStates());
    dispatch(fetchSchoolStates());
  }, []);
  useEffect(() => {
    if (state != "") {
      if (contractLevel == "College contract") {
        dispatch(getCollegeCity(state));
      } else {
        dispatch(getSchoolCounty(state));
      }
    }
  }, [state]);

  const defaultStateProps = {
    options:
      contractLevel == "College contract"
        ? states?.map((insti) => {
            return insti.name;
          })
        : schoolStates?.map((insti) => {
            return insti.name;
          }),
    getOptionLabel: (option) => option,
  };
  const defaultCollegeProps = {
    options:
      contractLevel === "College contract"
        ? [...(cities?.map((insti) => insti.city) ?? []), "OTHER"]
        : [...(counties?.map((insti) => insti.county) ?? []), "OTHER"],
    getOptionLabel: (option) => option,
  };

  let newSchools = [];
  const getInstitutes = () => {
    if (contractLevel == "College contract") {
      newCollegeUniversitiesData?.forEach((insti) => {
        insti.institutes?.forEach((ele) => {
          newSchools.push(ele);
        });
      });
    } else {
      newSchoolsAllData.forEach((insti) => {
        insti.institutes?.forEach((ele) => {
          newSchools.push(ele);
        });
      });
    }
    if (newSchools) {
      return newSchools;
    }
  };
  const defaultNewSchoolProps = {
    options: getInstitutes(),
    getOptionLabel: (option) => option,
  };

  const SubmitForm = (e) => {
    e.preventDefault();
    try {
      const payload = {
        state: state,
        school: newSchool,
        country: college,
        type: contractLevel,
      };
      dispatch(
        findContract(payload, (id) => {
          history.push(`/school-contract/${id}`);
        })
      );
    } catch (e) {
      toast.error("Error finding contract");
    }
  };

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div>
      <Link
        className="text-white btn btn-primary mx-4 my-3"
        onClick={handleGoBack}
      >
        <IoMdArrowBack /> Go Back
      </Link>
      <Container>
        <Card className="py-4 px-3 shadow">
          <Container>
            <Label className="mt-3 auth-label">
              Click for College or High School contract
            </Label>
            <div className="d-flex ml-4  mt-2 mb-4">
              <div>
                <Input
                  type="radio"
                  checked={contractLevel == "College contract"}
                  id="d_yes"
                  name="contractLevel"
                  value="College contract"
                  onChange={(e) => {
                    setContractLevel(e.target.value);
                    setState("");
                    setCollege("");
                    setNewSchool("");
                  }}
                />
                <Label
                  for="d_yes"
                  className={`auth-label ${
                    contractLevel == "College contract" ? "text-primary" : ""
                  }`}
                >
                  College contract
                </Label>
              </div>
              <div className="mx-auto">
                <Input
                  type="radio"
                  id="d_no"
                  name="contractLevel"
                  checked={contractLevel == "High School contract"}
                  value="High School contract"
                  onChange={(e) => {
                    setContractLevel(e.target.value);
                    setState("");
                    setCollege("");
                    setNewSchool("");
                  }}
                />
                <Label
                  for="d_no"
                  className={`auth-label ${
                    contractLevel == "High School contract"
                      ? "text-primary"
                      : ""
                  }`}
                >
                  High School contract
                </Label>
              </div>
            </div>

            <Label className="mt-2 auth-label">
              Address Where
              {contractLevel == "College contract"
                ? " College"
                : " School"}{" "}
              Located
            </Label>
            <br />
            <Form onSubmit={SubmitForm}>
              <div className="d-sm-flex">
                <div className="col-sm-4">
                  <Label className="auth-label mt-3">State</Label>
                  <Autocomplete
                    {...defaultStateProps}
                    id="auto-complete"
                    autoComplete
                    includeInputInList
                    value={state}
                    onChange={(e, val) => {
                      setState(val);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="State"
                        variant="standard"
                      />
                    )}
                  />
                </div>
                <div className="col-sm-4">
                  <Label className="auth-label mt-3">
                    {contractLevel == "College contract" ? "City" : "County"}
                  </Label>
                  <Autocomplete
                    {...defaultCollegeProps}
                    id="auto-complete-college"
                    autoComplete
                    includeInputInList
                    disabled={!state}
                    value={college}
                    onChange={(e, val) => {
                      if (val === "OTHER") {
                        setCollege(val);
                        setNewSchool("OTHER");
                      } else {
                        setCollege(val);
                        setNewSchool("");
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={"County"}
                        variant="standard"
                      />
                    )}
                  />
                </div>
                <div className="col-sm-4">
                  <Label className="auth-label mt-3">School</Label>
                  <Autocomplete
                    {...defaultNewSchoolProps}
                    id="auto-complete-school"
                    autoComplete
                    includeInputInList
                    value={newSchool}
                    disabled={!state || !college}
                    onChange={(e, val) => setNewSchool(val)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select your School from Dropdown menu"
                        variant="standard"
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true,
                        }}
                      />
                    )}
                  />{" "}
                </div>
              </div>
              <Button
                type="submit"
                className="mt-4 mb-3 float-right mr-2"
                color="primary"
              >
                View
              </Button>
            </Form>
          </Container>{" "}
        </Card>
      </Container>
    </div>
  );
};

export default SearchSchoolContract;
